import { render, staticRenderFns } from "./Postbacks.vue?vue&type=template&id=ac4e5de8&"
import script from "./Postbacks.vue?vue&type=script&lang=js&"
export * from "./Postbacks.vue?vue&type=script&lang=js&"
import style0 from "./Postbacks.vue?vue&type=style&index=0&id=ac4e5de8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports